/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment -- Disable all rules issued from linter */
import { Mention, Plugin } from 'ckeditor5';

export class UserMention extends Plugin {
  static get requires() {
    return [Mention];
  }

  init() {
    this._initUpcastConvertor();
    this._initDowncastConvertor();
  }

  private readonly _initDowncastConvertor = () => {
    const { editor } = this;

    // Downcast the model 'mention' text attribute to a view <a> element.
    editor.conversion.for('downcast').attributeToElement({
      converterPriority: 'high',
      model: 'mention',
      view(modelAttributeValue: any, { writer: viewWriter }: any) {
        // Do not convert empty attributes (lack of value means no mention).
        if (!modelAttributeValue) {
          return;
        }

        return viewWriter.createAttributeElement(
          'a',
          {
            class: 'mention',
            'data-mention': modelAttributeValue.id,
            'data-user-id': modelAttributeValue.userId,
            href: modelAttributeValue.link,
          },
          {
            // Prevent merging mentions together.
            id: modelAttributeValue.uid,
            // Make mention attribute to be wrapped by other attribute elements.
            priority: 20,
          },
        );
      },
    });
  };

  private readonly _initUpcastConvertor = () => {
    const { editor } = this;

    // The upcast converter will convert view <a class="mention" href="" data-user-id="">
    // elements to the model 'mention' text attribute.
    editor.conversion.for('upcast').elementToAttribute({
      converterPriority: 'high',
      model: {
        key: 'mention',
        value(viewItem: any): unknown {
          // The mention feature expects that the mention attribute value
          // in the model is a plain object with a set of additional attributes.
          // In order to create a proper object use the toMentionAttribute() helper method:
          return editor.plugins.get('Mention').toMentionAttribute(viewItem, {
            // Add any other properties that you need.
            link: viewItem.getAttribute('href'),
            // eslint-disable-next-line unicorn/prefer-dom-node-dataset -- Read user ID from data attribute
            userId: viewItem.getAttribute('data-user-id'),
          });
        },
      },
      view: {
        attributes: {
          'data-user-id': true,
          href: true,
        },
        // TODO: key: 'data-mention',
        classes: 'mention',
        name: 'a',
      },
    });
  };
}

/* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment -- Disable all rules issued from linter */
